import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import PlayersSearch from './search';
import SportMessages from 'components/molecules/message/sport';
import {ModeTabsComponent} from 'components/organisms/mode-tabs';
import FilterByPositions from 'components/organisms/filter-by-position';
import FilterByTiers from 'components/organisms/filter-by-tiers';
import PlayersList from './list';
import PlayersDashboard from './dasboard';
import FileDataReceiver from 'components/organisms/players-csv/upload-players-csv/components/file-data-receiver';

class Players extends Component {
    constructor(props) {
        super(props);
    }

    getFilterView() {
        const {sportConfig} = this.props;
        if (sportConfig.isGameTypeTiers()) {
            return <FilterByTiers />;
        } else if (sportConfig.usePositionFilter()) {
            return (
                <div className="position-filter">
                    <label>Select Positions</label>
                    <FilterByPositions simpleMode={true} enableRounded={true} />
                </div>
            );
        }
        return null;
    }

    canComponentBeRendered() {
        return true;
    }

    render() {
        if (!this.canComponentBeRendered()) {
            return null;
        }

        const {sportConfig, playersDropzone} = this.props;

        if (!sportConfig.isReady()) {
            return <div className="message-alert">{'Select sport, site and slate.'}</div>;
        }

        const filterView = this.getFilterView();

        return (
            <>
                <PlayersDashboard />
                <SportMessages />
                <div className={`table-filter-wrap ${filterView ? '' : 'without-position-filter'}`}>
                    <ModeTabsComponent />
                    {filterView}
                    <PlayersSearch />
                </div>
                <div className={`player-list-holder ${playersDropzone.show ? 'show-dropzone' : ''}`}>
                    <PlayersList />
                    <FileDataReceiver />
                </div>
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {playersData, sportConfig, playersDropzone} = state;

    return {
        sportConfig,
        playersDropzone,
        players: playersData.players,
    };
}

export default connect(mapStatesToProps)(Players);

export {Players};
